import coreStore from './core-store'

const remoteResource = 'operation/api/v1/operation-definition-groups';

export default coreStore.createCoreStore('operationDefinitionGroup', remoteResource);